import { logger } from '../core/logger';
import { resolveBookingProvider } from './bookingProviders';

/**
 * Try to open a booking URL as a popup using the provider's SDK (Calendly, Cal.com).
 *
 * Provider selection + the provider-specific SDK calls live in the booking
 * provider table (./bookingProviders). This just resolves the provider for the
 * URL and delegates to its overlay opener.
 *
 * @returns true if the popup was opened, false if fallback navigation is needed.
 */
export function tryOpenBookingPopup(url: string): boolean {
    try {
        const parsed = new URL(url);
        return resolveBookingProvider(url)?.openOverlay(parsed) ?? false;
    } catch {
        logger.warn('Failed to parse CTA URL for popup detection', { url });
        return false;
    }
}
